import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rbvgtaqimzpsarvoxubn.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJidmd0YXFpbXpwc2Fydm94dWJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYwMTAyNDEsImV4cCI6MjA2MTU4NjI0MX0.upjBkqkauSgswiCrYNWWRw6rTl_fLCHTzd87WWKi8Zc';

export const supabase = createClient(supabaseUrl, supabaseKey); 